// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase/compat/app";
import "firebase/compat/auth"
import "firebase/compat/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyCHna7vvtTiypYBINhtbS-m9-68G9oct-4",
  authDomain: "clone-5ea01.firebaseapp.com",
  projectId: "clone-5ea01",
  storageBucket: "clone-5ea01.appspot.com",
  messagingSenderId: "513307338091",
  appId: "1:513307338091:web:b25e5e08148757744ad82e",
  measurementId: "G-5RZSZEFTHB"
};

const firebaseApp=firebase.initializeApp(firebaseConfig);

const db=firebaseApp.firestore();
const auth=firebase.auth();

export {db,auth}